export const TIKTOK_STATUS_LABEL: Record<string, string> = {
  UNPAID: 'ยังไม่ได้ชำระเงิน',
  ON_HOLD: 'รอดำเนินการ',
  AWAITING_SHIPMENT: 'รอจัดส่ง',
  AWAITING_COLLECTION: 'รอเข้ารับสินค้า',
  PARTIALLY_SHIPPING: 'จัดส่งบางส่วน',
  IN_TRANSIT: 'กำลังจัดส่ง',
  DELIVERED: 'จัดส่งสำเร็จ',
  COMPLETED: 'เสร็จสิ้น',
  CANCEL: 'ยกเลิก',
  CANCELLED: 'ยกเลิก',
}

export const getStatusLabel = (status?: string): string =>
  TIKTOK_STATUS_LABEL[status ?? ''] ?? status ?? '-'

// สถานะที่ถือว่าขายสำเร็จ (ใช้คำนวณกำไร = ยอดสำเร็จ - ค่าใช้จ่าย)
export const SUCCESS_STATUSES = ['COMPLETED', 'DELIVERED']

// สถานะยกเลิก — ตรงกับ CANCELLED_STATUSES ฝั่ง apps/tiktok (CANCEL = ค่าที่ webhook รุ่นเก่าเคยส่ง)
export const CANCELLED_STATUSES = ['CANCELLED', 'CANCEL']
